module.exports = __webpack_public_path__ + "img/main_section_img6.69cd4d5d.png";